<!-- Header -->
@if (slideAuthorFacade.currentSelectedSlideAnnotationLabel$ | async; as label) {
  <medsurf-slide-edit-header
    [icon]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.ANNOTATION_MARKER"
    [label]="label.text"
  [type]="'enum.annotation_type.Marker'"></medsurf-slide-edit-header>
}
<!-- Content -->
<div #edit_overlay_template_scroll_panel
  class="flex flex-1 overflow-auto justify-content-center">
  <!-- Accordion -->
  <p-accordion [activeIndex]="[0, 1, 2]"
    [multiple]="true"
    styleClass="no_border"
    class="w-full h-full ml-3 mr-3">
    <p-accordionTab [header]="'global.general' | translate"
      headerStyleClass="uppercase">
      <div class="flex flex-column align-items-center">
        <!-- Name -->
        <medsurf-slide-edit-shared-name-form [class]="'w-full'"></medsurf-slide-edit-shared-name-form>

        <!-- Link -->
        <medsurf-slide-edit-shared-link-form [class]="'w-full'"></medsurf-slide-edit-shared-link-form>

        <!-- Selftest -->
        <medsurf-slide-edit-shared-selftest-form [class]="'w-full'"></medsurf-slide-edit-shared-selftest-form>
      </div>
    </p-accordionTab>
    <p-accordionTab [header]="'global.layout' | translate"
      headerStyleClass="uppercase">
      <div class="flex flex-column align-items-center">
        <!-- Text Layout -->
        <medsurf-slide-edit-shared-text-layout-form [class]="'w-full'"></medsurf-slide-edit-shared-text-layout-form>

        <!-- Annotation Layout -->
        <medsurf-slide-edit-marker-targets-form [class]="'w-full'"></medsurf-slide-edit-marker-targets-form>
      </div>
    </p-accordionTab>
    <p-accordionTab [header]="'global.relation' | translate"
      headerStyleClass="uppercase">
      <div class="flex flex-column align-items-center">
        <!-- Images -->
        <medsurf-slide-edit-shared-image-form [class]="'w-full'"></medsurf-slide-edit-shared-image-form>

        <!-- POIs -->
        <medsurf-slide-edit-shared-poi-form [class]="'w-full'"></medsurf-slide-edit-shared-poi-form>

        <!-- Groups -->
        <medsurf-slide-edit-shared-group-form [class]="'w-full'"></medsurf-slide-edit-shared-group-form>
      </div>
    </p-accordionTab>
  </p-accordion>
</div>